import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Header = () => {
    const navigate = useNavigate()
    const { pathname } = useLocation();
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

    // Toggle mobile menu state
    const toggleMobileMenu = () => {
        setMobileMenuOpen(!isMobileMenuOpen);
    };

    const studentToken = localStorage.getItem('student-token');
    const tutorToken = localStorage.getItem('tutor-token');


    const handleLoginClick = () => {
        if (studentToken) {
            navigate('/student/dashboard');
        }
        else if (tutorToken) {
            navigate('/tutor/dashboard');
        }
        else {
            navigate('/login');
        }


    }


    return (
        <header>
            <div id="home">
                <header className="header-wrap style1">
                    <div className="container">
                        <div className="header-bottom">
                            <div className="row align-items-baseline justify-content-between">
                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 d-flex justify-content-center">
                                    <Link to="/" className="logo">
                                        <img
                                            src="/website/assets/img/logo.png"
                                            alt="Image"
                                            className="img-fluid"
                                        />
                                    </Link>
                                </div>
                                <div className="col-xl-6 col-lg-2 col-md-2 col-sm-2">
                                    <div className={`main-menu-wrap ${isMobileMenuOpen ? 'open' : ''}`}>
                                        <div className="menu-close d-xl-none" onClick={toggleMobileMenu}>
                                            <Link to="javascript:void(0)">
                                                <i className="las la-times" />
                                            </Link>
                                        </div>
                                        <nav id="menu">
                                            <ul className="main-menu list-unstyled d-flex justify-content-center">
                                                <li className="has-children">
                                                    <Link className={`${pathname === '/' ? 'active' : ''}`} to="/">
                                                        Home
                                                    </Link>
                                                </li>
                                                <li className="has-children">
                                                    <Link className={`${pathname === '/find-tutor' ? 'active' : ''}`} to="/find-tutor">Find a Tutor</Link>
                                                </li>
                                                <li className="has-children">
                                                    <Link className={`${pathname === '/become-tutor' ? 'active' : ''}`} to="/become-tutor">Become a Tutor</Link>
                                                </li>
                                                <li className="has-children">
                                                    <Link className={`${pathname === '/about-us' ? 'active' : ''}`} to="/about-us">About Us</Link>
                                                </li>
                                                <li className="has-children">
                                                    <Link className={`${pathname === '/blog' ? 'active' : ''}`} to="/blog">Blog</Link>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                                <div
                                    className="col-xl-3 col-lg-3 col-md-3 col-sm-3"
                                    style={{ width: "fit-content" }}
                                >
                                    <ul
                                        className="nav header-navbar-rht d-flex justify-content-end"
                                        style={{ gap: 10 }}
                                    >
                                        <li className="nav-item">
                                            <Link className={`${pathname === '/register' ? 'nav-link header-login' : 'nav-link'}`} to="/register">
                                                Register
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <a className={`${pathname === '/login' ? 'nav-link header-login' : 'nav-link'}`} onClick={handleLoginClick}>
                                                {studentToken || tutorToken ? 'Go to dashboard' : 'Log In'}

                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div
                                    className="col-lg-4 col-md-4 col-sm-4"
                                    style={{ width: "fit-content" }}
                                >
                                    <div className="mobile-bar-wrap d-xl-none">
                                        <div className="mobile-top-bar" onClick={toggleMobileMenu}>
                                            <span />
                                            <span />
                                            <span />
                                        </div>
                                        <div className="mobile-menu">
                                            <Link to="javascript:void(0)" onClick={toggleMobileMenu}>
                                                <i className="las la-bars" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            </div>
        </header>
    );
};

export default Header;
